    export const accessHelper = (account) => {        
        if(!account?.idTokenClaims?.state) return 0;
        if(account?.idTokenClaims.state === 'Lamberti Labs' || account?.idTokenClaims.state === 'Tourismus Klosterneuburg') return 1;
        if(account?.idTokenClaims.state && (account?.idTokenClaims.state !== 'Lamberti Labs' || account?.idTokenClaims.state !== 'Tourismus Klosterneuburg')) return 2;        
    }

    export const accessHelperText = (account) => {        
        if(!account?.idTokenClaims?.state) { return 'Lesen' };
        if(account?.idTokenClaims.state === 'Lamberti Labs' || account?.idTokenClaims.state === 'Tourismus Klosterneuburg') return <span><b>Admin</b></span>        
        if(account?.idTokenClaims.state && (account?.idTokenClaims.state !== 'Lamberti Labs' || account?.idTokenClaims.state !== 'Tourismus Klosterneuburg')) { return `Änderungen für ${account?.idTokenClaims.state}`; }                
    }

    export const isEditPermitted = (account, heuriger) => {
        if(accessHelper(account) === 2 && heuriger === account?.idTokenClaims.state) { return true }
        if(accessHelper(account) === 1) { return true }
        return false;
    }